import React from "react";



function Doctorpatientdtails1() {
    return (
        <main className="doctorpatientdtails1">
            <div className="container-fluid"  style={{ marginBottom: "100px", marginTop: "100px" }}>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title"> Patient Details</h5>
                                <hr />
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="card h-100">
                                            <div className="card-body">

                                                <img src="/image/logo.png" className="card-img-top w-50 " alt="..." />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-8">
                                        <div className="card h-100">
                                            <div className="card-body">
                                                <div className="table">
                                                    <table className="table table-bordered  table-striped">
                                                        <thead>
                                                        <tr>
                                                    <th scope="row">Name</th>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Experience</th>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Genter</th>
                                                    <td>dsdsdsdsfsf</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Address</th>
                                                    <td>dsdsdsdsfsf</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Phone</th>
                                                    <td>dsdsdsdsfsf</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Date Of Birth</th>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Email</th>
                                                </tr>
                                                        </thead>

                                                    </table>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    )
}

export default Doctorpatientdtails1;